import { UseFormWatch } from "react-hook-form";
import { deformatCurrency } from "@trussle/external-components";
import { IRateWatchPanelFormValues } from ".";

const updateHubspotFormValue = (inputName: string, value?: string | null | number) => {
  const input = document.querySelector(
    `#hubspot-form-44627b0e-742e-4c43-a8bb-f499c6195f0a input[name="${inputName}"]`,
  ) as HTMLInputElement;
  if (input && value) {
    input.value = value.toString();
  }
};

export const useHubspotPopulateFields = (watch: UseFormWatch<IRateWatchPanelFormValues>, endDateValue: Date) => () => {
  const repaymentValue = watch("repayment");
  const propertyValue = watch("propertyValue");
  const balance = watch("balance");

  updateHubspotFormValue("rate_watch_repayment", Number(deformatCurrency(repaymentValue!)));
  updateHubspotFormValue("rate_watch_end_date", `${endDateValue?.getFullYear()}-${
    ((endDateValue?.getMonth() || 0) + 1).toString().padStart(2, "0")
  }-01`);
  updateHubspotFormValue("rate_watch_balance", Number(deformatCurrency(balance!)));
  updateHubspotFormValue("rate_watch_value", Number(deformatCurrency(propertyValue!)));
};
